import { getToken } from '../functions/storage-functions';
import { httpClient } from './http-client';
import { AxiosResponse } from 'axios';

export class HttpRepository {
    protected createAuthorizationDocumentsHeader(): { headers } {
        const headerRequest = {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
            responseType: 'arraybuffer',
        };
        return headerRequest;
    }

    protected createAuthorizationHeader(): { headers } {
        const headerRequest = {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        };
        return headerRequest;
    }

    protected createUri(path: string | any[], queryString?: string | object): string {
        let uri: string = ``;

        if (path) {
            if (path instanceof String) {
                path = path.charAt(0) === '/' ? path : '/' + path;
                uri += path;
            } else if (path instanceof Object) {
                const originalPath = path.join('/');
                uri += originalPath.charAt(0) === '/' ? originalPath : '/' + originalPath;
            }
        }

        if (queryString) {
            uri += '?';

            if (queryString instanceof String) {
                uri += queryString;
            } else if (queryString instanceof Array) {
                uri += queryString.join('&');
            } else if (queryString instanceof Object) {
                const query: string[] = [];

                Object.keys(queryString).forEach((key: string) => {
                    if (queryString[key]) {
                        query.push(`${key}=${queryString[key]}`);
                    }
                });

                uri += query.join('&');
            }
        }

        return uri;
    }

    protected post(uri: string, data: any, header: any): Promise<AxiosResponse<any>> {
        return httpClient.post(uri, data, header);
    }

    protected get(uri: string, header: any) {
        return httpClient.get(uri, header);
    }

    protected patch(uri: string, data: any, header: any) {
        return httpClient.patch(uri, data, header);
    }

    protected delete(uri: string, header: any) {
        return httpClient.delete(uri, header);
    }
}
